export const url = 'AvisoSegurado.aspx';

// Configs from backend

/**
 * Captcha key used for the Captcha component
 */
export const captchaKeySetting = window.captchaKey;

/**
 * Countdown timer value to fill the email code
 */
export const timerSecondsSetting = window.timerSeconds;

/**
 * Available products for the app, used to create app routing and filter in policy search
 */
export const AxaRamosInfo = window.availableProducts;

/**
 * DEPRECATED
 * Gets the formated year range for the Calendar component
 * @param {number} startYear year to start
 * @returns Formated string with {startYear} to current year
 */
export const yearRange = startYear => `${startYear}:${new Date().getUTCFullYear()}`;

/**
 * Available branches for Axa, used in routing and to filter the product in policy search.
 * NOT USED -  DELETE
 */
export const AxaRamos = [
  // {
  //   ids: [71], //SinistroRamo
  //   name: "BolsaProtegida",
  //   desc: "Bolsa Protegida",
  //   path: "/bolsa",
  //   icon: "pi pi-shield",
  // },
  // {
  //   ids: [147],
  //   name: "Danos",
  //   desc: "Microsseguro de Danos",
  //   path: "/danos",
  //   icon: "pi pi-eye",
  // },
  {
    ids: [95],
    name: 'GarantiaEstendida',
    desc: 'Garantia Estendida',
    path: '/garantia',
    icon: 'fa fa-plus-circle'
  },
  {
    ids: [71],
    name: 'RouboFurto',
    desc: 'Roubo e Furto',
    path: '/roubofurto',
    icon: 'fa fa-grimace'
  },
  {
    ids: [91, 93],
    name: 'Vida',
    desc: 'Vida',
    path: '/vida',
    icon: 'fa fa-heart'
  },
  {
    ids: [80, 81, 82, 83, 84], // IDs dos ramos de transportes
    name: 'Transportes',
    desc: 'Transportes',
    path: '/transportes',
    icon: 'fa fa-truck'
  }
];

export const AREA_NEGOCIO = {
  PeC: 36,
  Vida: 34,
  Partnerships: 35,
  AfinidadesDemaisProdutos: 37,
  Financial: 48,
  Transportes: 49
};

export const PRODUCT_NAME = {
  GarantiaEstendida: 'GarantiaEstendida',
  RouboFurto: 'RouboFurto'
};

export const MASKS = {
  telemovel: '(00) 00000-0000',
  telefone: '(00) 0000-0000',
  cpfCnpjMask: [
    {
      mask: '000.000.000-00'
    },
    {
      mask: '00.000.000/0000-00'
    }
  ]
};

export const FORMS = {
  AeronauticoRetaCasco: 1,
  EeODeO: 2,
  GarantiaPublica: 3,
  GarantiaEstendida: 4,
  Grupos123: 5,
  ProtecaoFinanceira: 6,
  RDEquipamentos: 7,
  Residencial: 8,
  RouboFurto: 9,
  Transportes: 10,
  Viagem: 11,
  Vida: 12,
  BolsaProtegida: 13,
  Financial: 15
};

// 1	Formulário Aeronáutico Reta / Casco
// 2	Formulário E&O e D&O
// 3	Formulário Garantia Pública e Garantia Privada
// 4	Formulário Garantia Estendida e Quebra Acidental
// 5	Formulário Grupos I III e IV
// 6	Formulário Proteção Financeira/Prestamista
// 7	Formulário RD Equipamentos
// 8	Formulário Residencial e Micro Seguro de Danos
// 9	Formulário Roubo e Furto
// 10	Formulário Transportes
// 11	Formulário Viagem Individual e Coletiva
// 12	Formulário Vida e Acidentes Pessoais
// 13	Formulário Bolsa Protegida

/**
 * GDMTipo config to use in getGDMTiposFiltro()
 */
export const GDM_TIPO_FILTER = {
  RouboFurto: 'GDMTipoRouboFurto',
  BolsaProtegida: 'BolsaProtegida'
};

export const GDM_TIPO = {
  celular: 17
};

/**
 * Id's to filter for 'ComunicanteContacto.ParentescoId'.
 */
// export const filtrosVinculo = [1, 7, 8, 10];
export const filtrosVinculo = [1, 5, 7, 8, 10];
// 1 o próprio, parente, amigo, conhecido, 10 lojista, 5 outros
/**
 * General config for Swal.
 */
export const swalConfig = {
  showCancelButton: false,
  showCloseButton: false,
  allowOutsideClick: false,
  allowEnterKey: false,
  allowEscapeKey: false
};

export const currencyOptions = {
  currency: 'BRL',
  locale: 'pt-BR',
  hideCurrencySymbolOnFocus: false,
  hideGroupingSeparatorOnFocus: false,
  hideNegligibleDecimalDigitsOnFocus: false
};

export const localePT = {
  startsWith: 'Começa com',
  contains: 'Contem',
  notContains: 'Não contem',
  endsWith: 'Acaba com',
  equals: 'Igual',
  notEquals: 'Desigual',
  noFilter: 'Sem filtro',
  lt: 'Menor que',
  lte: 'Menor ou igual a',
  gt: 'Maior que',
  gte: 'Maior ou igual a',
  dateIs: 'Data é',
  dateIsNot: 'Data não é',
  dateBefore: 'Data é antes',
  dateAfter: 'Data é depois',
  clear: 'Limpar',
  apply: 'Aplicar',
  matchAll: 'Corresponder a todos',
  matchAny: 'Corresponder a qualquer',
  addRule: 'Adicionar Regra',
  removeRule: 'Remover REGRA',
  accept: 'Sim',
  reject: 'Não',
  choose: 'Selecione',
  upload: 'Upload',
  cancel: 'Cancelar',
  dayNames: ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
  dayNamesShort: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
  dayNamesMin: ['Dm', 'Sg', 'Tr', 'Qa', 'Qi', 'Sx', 'Sb'],
  monthNames: [
    'Janeiro',
    'Fevereiro',
    'Março',
    'Abril',
    'Maio',
    'Junho',
    'Julho',
    'Agosto',
    'Setembro',
    'Outubro',
    'Novembro',
    'Dezembro'
  ],
  monthNamesShort: [
    'Jan',
    'Fev',
    'Mar',
    'Abr',
    'Mai',
    'Jun',
    'Jul',
    'Ago',
    'Set',
    'Out',
    'Nov',
    'Dez'
  ],
  today: 'Hoje',
  weekHeader: 'Sm',
  firstDayOfWeek: 0,
  dateFormat: 'dd/mm/yy',
  weak: 'Fraco',
  medium: 'Medio',
  strong: 'Forte',
  passwordPrompt: 'Preencha password',
  emptyFilterMessage: 'Sem resultados',
  emptyMessage: 'Sem opções'
};

export const PLLids = [2, 17, 22, 25, 26, 33, 34, 35, 36];

export const locationDefaultObject = {
  address: undefined,
  number: undefined,
  countryId: undefined,
  countryDescription: undefined,
  stateId: undefined,
  stateDescription: undefined,
  cityId: undefined,
  cityDescription: undefined,
  localityId: undefined,
  localityDescription: undefined,
  complement: undefined
};

export const iMaskConfig = {
  maskCpf: [
    {
      mask: '000.000.000-00'
    }
  ],
  telemovel: [
    {
      mask: '(00) 0000-0000',
      lazy: false
    }
  ],
  telefone: [
    {
      mask: '(00) 0000-0000',
      lazy: false
    }
  ]
};

export const PRODUTOS_MARITIMOS = [193, 194];

export const PRODUTOS_AERONAUTICOS = [144, 148, 149, 191, 192];
